module.exports = __webpack_public_path__ + "img/background-lg.7632c997.jpg";